window.dtDepartment = function () {
  const dt_department = new DataTable('#department-datatable', {
    processing: false,
    serverSide: true,
    responsive: true,
    ajax: {
      url: $('#department-datatable').data('source'),
      beforeSend: function () { showLoadingRow('#department-datatable', 4); },
      complete: function () { hideLoadingRow(); }
    },
    pagingType: "full_numbers",
    order: [[3, 'desc'], [0, 'asc']],
    columns: [
      { "data": "index" },
      { "data": "status" },
      { "data": "name" },
    ],
    columnDefs: [
    ],
    language: {
      search: ' ',
      sLengthMenu: '_MENU_',
      searchPlaceholder: "Search...",
      info: "Showing _START_ to _END_ of _TOTAL_ entries"
    },
    rowCallback: function (row, data, index) {
      $('td', row).addClass('py-1');
    },
  });

  dtFinalTouch()
}

 